import {PrinterService} from "./printer_service";

export async function go(token: string, subText: string, baseUrl: string, device: any): Promise<PrinterService> {
    console.log ('printing')
    // let devices = await navigator.usb.getDevices()
    // let device = devices[0]
    // 'https://mgmt.test-31415.wartenummer.at/wartezimmer/dr-test'
    return await PrinterService.run(token, device, () => {}, baseUrl, subText)
}
